"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Carousel = void 0;
require("@splidejs/splide/dist/css/splide-core.min.css");
var splide_1 = __importDefault(require("@splidejs/splide"));
var vue_1 = require("vue");
exports.Carousel = vue_1.defineComponent({
    name: 'Carousel',
    props: {
        itemCount: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: false,
            "default": 5,
        },
        pagination: {
            type: Boolean,
            required: false,
            "default": false
        },
        arrowsColor: {
            type: String,
            required: false,
            "default": 'green',
            validator: function (value) { return ['green', 'white'].indexOf(value) !== -1; },
        },
        arrowsVerticalCenter: {
            type: Boolean,
            required: false,
            "default": false
        }
    },
    setup: function (props) {
        var splideId = vue_1.ref("a" + Math.random().toString(36).substr(2));
        vue_1.onMounted(function () {
            var splide = new splide_1["default"]("#" + splideId.value, {
                perPage: props.perPage,
                perMove: props.perPage,
                rewind: true,
                // type: 'loop',
                autoWidth: false,
                autoplay: true,
                pagination: props.pagination,
                gap: '3rem',
                // @ts-ignore
                arrows: 'slider',
                breakpoints: {
                    600: {
                        perPage: props.perPage === 1 ? 1 : 2,
                        perMove: props.perPage === 1 ? 1 : 2,
                    },
                    900: {
                        perPage: props.perPage === 1 ? 1 : 3,
                        perMove: props.perPage === 1 ? 1 : 3,
                    },
                    1130: {
                        perPage: props.perPage === 1 ? 1 : 4,
                        perMove: props.perPage === 1 ? 1 : 4,
                    },
                }
            });
            splide.mount();
        });
        return {
            splideId: splideId,
        };
    },
    template: /* html */ "\n        <div class=\"splide\" :id=\"splideId\">\n            <div class=\"splide__slider pb-28 lg:pb-0\">\n                <div\n                    class=\"splide__arrows absolute w-full flex items-center justify-around lg:justify-between bottom-0 lg:bottom-auto z-5 lg:z-0\"\n                    :class=\"{ 'lg:h-full': arrowsVerticalCenter, 'lg:h-84': !arrowsVerticalCenter, 'pt-0': arrowsVerticalCenter, 'lg:pt-24': !arrowsVerticalCenter }\"\n                >\n                    <button class=\"splide__arrow splide__arrow--prev border-none shadow-none\">\n                        <i class=\"icon-angle-left text-80\" :class=\"{ ['text-' + arrowsColor]: true }\"></i>\n                    </button>\n                    <button class=\"splide__arrow splide__arrow--next border-none shadow-none\">\n                        <i class=\"icon-angle-right text-80\" :class=\"{ ['text-' + arrowsColor]: true }\"></i>\n                    </button>\n                </div>\n\n                <div class=\"px-12 lg:px-24 2xl:px-48 py-12\">\n                    <div class=\"splide__track\">\n                        <slot></slot>\n                    </div>\n                </div>\n            </div>\n        </div>\n    ",
});
